import React from "react";
import { Heading, Stack, Text } from "@commonsku/design-system";
import AutomationEarlyAccessAlert from "./AutomationEarlyAccessAlert";
import AutomationList from "./AutomationList";
import { useWorkflowAutomations } from "./useWorkflowAutomations";

/**
 * Top-level page for the automations list screen (`/automations`).
 */
const AutomationsPage = () => {
  const { workflows, loading, togglingWorkflowId, toggleActive } = useWorkflowAutomations();

  return (
    <Stack gap="6" paddingBottom="4" paddingRight="4" align="stretch">
      <Stack gap="2">
        <Heading size="2xl" margin="0!">
          Automations
        </Heading>
        <Text fontSize="sm" color="fg.muted" margin="0!">
          This is where you can view and manage your automations.
        </Text>
      </Stack>
      <AutomationEarlyAccessAlert />
      <AutomationList
        workflows={workflows}
        loading={loading}
        togglingWorkflowId={togglingWorkflowId}
        onToggleActive={toggleActive}
      />
    </Stack>
  );
};

export default AutomationsPage;
